import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const StorePage = lazy(() => import('../pages/store/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ReferencesPage = lazy(() => import('../pages/references/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const CataloguePage = lazy(() => import('../pages/catalogue/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const SignInPage = lazy(() => import('../pages/signin/page'));
const WishlistPage = lazy(() => import('../pages/wishlist/page'));
const RealisationsPage = lazy(() => import('../pages/realisations/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/store',
    element: <StorePage />,
  },
  {
    path: '/product/:id',
    element: <ProductPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/references',
    element: <ReferencesPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/catalogue',
    element: <CataloguePage />,
  },
  {
    path: '/quote',
    element: <QuotePage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/signin',
    element: <SignInPage />,
  },
  {
    path: '/wishlist',
    element: <WishlistPage />,
  },
  {
    path: '/realisations',
    element: <RealisationsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
